import authService from './authService';
import { buildHeaders, buildHeadersForUpload } from "src/utils/apiUtils";


import { UpdateControlInput } from "src/validation.ts/controls";
import { CreateAssertionInput } from "src/validation.ts/AssertionType";




let BASE_URL = process.env.REACT_APP_API_URL

export async function loadConfig() {
  // .env is used directly; no encrypted config to load.
}

loadConfig().then(() => {
});

export async function getReferencesInCompliance(
  query: string, perPage: number, pageNo: number,
  sortBy?: string, sortOrder?: 'asc' | 'desc',
) {
  try {

      const headers = await buildHeaders(BASE_URL);
      const sortParams = `${sortBy ? `&sortBy=${encodeURIComponent(sortBy)}` : ''}${sortOrder ? `&sortOrder=${sortOrder}` : ''}`;
      const response = await fetch(`${BASE_URL}/control-references/in-compliance?query=${encodeURIComponent(query)}&perPage=${perPage}&pageNo=${pageNo}${sortParams}`, {
          method: "GET",
          headers,
          credentials: "include",
      });

      const data = await response.json();
      
      if (!response.ok) {
          if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
              throw new Error("Forbidden: You do not have permission to access this resource.");
          }
          throw new Error(data?.message || `HTTP ${response.status}: Failed to fetch references`);
      }
      
      // Only check data.success if the response is ok (200-299)
      if (data.success === false) {
          throw new Error(data?.message || 'API returned success: false');
      }
      
      return data;
  } catch (error: any) {
      console.error('getReferencesInCompliance error:', error);
      throw error;
  }
}


export async function getReferences(queryOrParams: string | { query?: string; perPage?: number; pageNo?: number }, _perPage?: number, _pageNo?: number) {
  try {

      const headers = await buildHeaders(BASE_URL);
      // const response = await fetch(`${BASE_URL}/control-references?query=${query}&perPage=${perPage}&pageNo=${pageNo}`, {
        const response = await fetch(`${BASE_URL}/control-references/getAll`, {
          method: "GET",
          headers,
          credentials: "include",
      });

    

      const data = await response.json();
      if (!response.ok || !data.success) {
          if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
              throw new Error("Forbidden: You do not have permission to access this resource.");
          }
          //console.log("Failed to fetch");
      }
      return data;
  } catch (error: any) {
      //console.log(error);
  }
}



export async function getCoso(){
    try {
        const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/coso`,{method:"GET",headers,credentials:"include"});
      if (!response.ok) {
        //console.log('Failed to fetch data');
      }
      return response.json();
    } catch (error) {
      //console.log('Failed to fetch data');
    }
    
}

export async function getCobit(){
    try {

      
       const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/cobit`,{method:"GET",headers,credentials:"include"});

      if (!response.ok) {
        //console.log('Failed to fetch data');
      }
      return response.json();
    } catch (error) {
      //console.log('Failed to fetch data');
    }
    
}


export async function getCBE(){
    try {
      const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/cbe-function`,{method:"GET",headers,credentials:"include"});

      if (!response.ok) {
        //console.log('Failed to fetch data');
      }
      return response.json();
    } catch (error) {
      //console.log('Failed to fetch data');
    }
    
}


export async function getNIST(){
    try {
       const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/nist`,{method:"GET",headers,credentials:"include"});

      if (!response.ok) {
        //console.log('Failed to fetch data');
      }
      return response.json();
    } catch (error) {
      //console.log('Failed to fetch data');
    }
    
}


export async function getISO(){
    try {
       const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/iso`,{method:"GET",headers,credentials:"include"});

      if (!response.ok) {
        //console.log('Failed to fetch data');
      }
      return response.json();
    } catch (error) {
      //console.log('Failed to fetch data');
    }
    
}

export async function getControlByCBE(id: any) {
    try {
      const headers = await buildHeaders(BASE_URL);
        const response = await fetch(`${BASE_URL}/control-cbe/by-cbe?cbe_id=${id}`, { method: "GET", headers,credentials:"include" });

        if (!response.ok) {
            //console.log('Failed to fetch data');
        }
        return response.json();
    } catch (error) {
        //console.log('Failed to fetch data');
    }
}

export async function getControlByISO(id:any){
    try {
      const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/control-iso/${id}`,{method:"GET",headers,credentials:"include"});
      if (!response.ok) {
        //console.log('Failed to fetch data');
      }
      return response.json();

    } catch (error) {
      //console.log('Failed to fetch data');
    }
}


export async function getControlByCobit(id:any){
    try {
      const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/control-cobit/${id}`,{method:"GET",headers,credentials:"include"});
      if (!response.ok) {
        //console.log('Failed to fetch data');
      }
      return response.json();

    } catch (error) {
      //console.log('Failed to fetch data');
    }
} 


export async function getControlByCoso(id:any){
    try {
      const headers = await buildHeaders(BASE_URL);  

      const response = await fetch(`${BASE_URL}/control-coso/${id}`,{method:"GET",headers,credentials:"include"});
      if (!response.ok) {
        //console.log('Failed to fetch data');
      }
      return response.json();

    } catch (error) {
        //console.log('Failed to fetch data');
    }
}

export async function getControlByNist(id:any){
    try {
      const headers = await buildHeaders(BASE_URL);


      const response = await fetch(`${BASE_URL}/control-nist/${id}`,{method:"GET",headers,credentials:"include"});
      if (!response.ok) {
        //console.log('Failed to fetch data');
      }
      return response.json();
    } catch (error) {
      //console.log('Failed to fetch data');
    }
} 


export async function uploadExcel(
  file: File,
  options?: { domainId?: string | null; standardId?: string; uploadType?: 'full' | 'domain' | 'control' }
) {
  try {
      const formData = new FormData();
      formData.append('file', file);

      if (options?.domainId) formData.append('domainId', options.domainId);
      if (options?.standardId) formData.append('standardId', options.standardId);
      if (options?.uploadType) formData.append('uploadType', options.uploadType);
      // Standards and controls uploaded from this app belong to compliance — same
      // rule the create/update calls above follow. Not a user-facing choice, so it
      // is set here rather than exposed as a form field. adib-frontend (DCC) sends
      // nothing and its uploads keep the column default 'all'.
      formData.append('appScope', 'compliance');

      const headers = await buildHeadersForUpload(BASE_URL);
      const response = await fetch(`${BASE_URL}/domain/upload-template`, {
          method: "POST",
          body: formData,
          headers,
          credentials:"include",
      });

      const contentType = response.headers.get('content-type') || '';
      const isJson = contentType.includes('application/json');
      const payload = isJson ? await response.json() : await response.text();

      if (!response.ok) {
          const message = isJson ? (payload?.message || 'Failed to upload Excel file') : (payload || 'Failed to upload Excel file');
          throw new Error(message);
      }

      return isJson ? payload : { success: true, message: String(payload) };
  } catch (error: any) {
      throw new Error(error?.message || 'Failed to upload Excel file');
  }
}


export async function createStandard(payload: { name: string; description?: string; workflowId?: string }) {
  try {
    const headers = await buildHeaders(BASE_URL);

    const response = await fetch(`${BASE_URL}/control-references`, {
      method: "POST",
      headers,
      credentials: "include",
      // Standards created here always belong to the compliance app — not a
      // user-facing choice, so it's set automatically rather than exposed as a form field.
      body: JSON.stringify({ ...payload, appScope: "compliance" }),
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data?.message || 'Failed to create standard');
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to create standard');
  }
}

export async function updateStandard(id: string, payload: { name?: string; description?: string; workflowId?: string }) {
  try {
    const headers = await buildHeaders(BASE_URL);

    const response = await fetch(`${BASE_URL}/control-references/${id}`, {
      method: "PATCH",
      headers,
      credentials: "include",
      // Keep it compliance-scoped on every edit made from this app.
      body: JSON.stringify({ ...payload, appScope: "compliance" }),
    });

    const data = await response.json();
    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data?.message || 'Failed to update standard');
    }
    // The full reply: success:false (refused), pendingApproval (held as a change request)
    // or restarted (saved, approval back in Draft) — the caller tells the user which.
    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to update standard');
  }
}

export async function deleteStandard(id: string) {
  try {
    const headers = await buildHeaders(BASE_URL);

    const response = await fetch(`${BASE_URL}/control-references/${id}`, {
      method: "DELETE",
      headers,
      credentials: "include",
    });

    const data = await response.json();
    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data?.message || 'Failed to delete standard');
    }
    // The full reply: success:false (refused), pendingApproval (held as a change request)
    // or restarted (saved, approval back in Draft) — the caller tells the user which.
    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to delete standard');
  }
}

/** Bare id/code/name list for the export picker — every standard, not just the current page. */
export async function getStandardsExportOptions(): Promise<Array<{ id: string; code: string; name: string }>> {
  const headers = await buildHeaders(BASE_URL);
  const response = await fetch(`${BASE_URL}/control-references/export/options`, {
    method: "GET",
    headers,
    credentials: "include",
  });
  const data = await response.json();
  if (!response.ok || !data.success) {
    if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
      throw new Error("Forbidden: You do not have permission to access this resource.");
    }
    throw new Error(data?.message || 'Failed to load standards');
  }
  return data.data || [];
}

/** Excel export (standard -> domain -> subdomain -> control) for the given standard ids. */
export async function exportStandardsExcel(standardIds: string[]): Promise<{ blob: Blob; filename: string }> {
  const headers = await buildHeaders(BASE_URL);
  const response = await fetch(`${BASE_URL}/control-references/export`, {
    method: "POST",
    headers,
    credentials: "include",
    body: JSON.stringify({ standardIds }),
  });

  if (!response.ok) {
    let message = 'Failed to export standards';
    try {
      message = (await response.json())?.message || message;
    } catch {
      /* not JSON — keep the fallback */
    }
    if (response.status === 401 || response.status === 403) {
      throw new Error("Forbidden: You do not have permission to export this data.");
    }
    throw new Error(message);
  }

  const disposition = response.headers.get('Content-Disposition') || '';
  const match = /filename="?([^";]+)"?/i.exec(disposition);
  return { blob: await response.blob(), filename: match?.[1] || 'standards_export.xlsx' };
}


// Domain CRUD operations
export async function createDomain(domainData: any) {
  try {
    const headers = await buildHeaders(BASE_URL);

    const response = await fetch(`${BASE_URL}/domain`, {
      method: "POST",
      headers,
      credentials: "include",
      body: JSON.stringify(domainData),
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data?.message || 'Failed to create domain');
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to create domain');
  }
}

export async function updateDomain(id: string, domainData: any) {
  try {
    const headers = await buildHeaders(BASE_URL);

    const response = await fetch(`${BASE_URL}/domain/${id}`, {
      method: "PATCH",
      headers,
      credentials: "include",
      body: JSON.stringify(domainData),
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data?.message || 'Failed to update domain');
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to update domain');
  }
}

export async function deleteDomain(id: string) {
  try {
    const headers = await buildHeaders(BASE_URL);

    const response = await fetch(`${BASE_URL}/domain/${id}`, {
      method: "DELETE",
      headers,
      credentials: "include",
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data?.message || 'Failed to delete domain');
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to delete domain');
  }
}

export async function getAllDomains() {
  try {
    const headers = await buildHeaders(BASE_URL);

    const response = await fetch(`${BASE_URL}/domain/getAll`, {
      method: "GET",
      headers,
      credentials: "include",
    });

    const data = await response.json();
    
    // Log the response for debugging
    //console.log('getAllDomains response:', { status: response.status, data });
    
    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data?.message || `HTTP ${response.status}: Failed to fetch domains`);
    }
    
    // Only check data.success if the response is ok (200-299)
    if (data.success === false) {
      throw new Error(data?.message || 'API returned success: false');
    }
    
    return data;
  } catch (error: any) {
    console.error('getAllDomains error:', error);
    throw new Error(error?.message || 'Failed to fetch domains');
  }
}




// update control apio

export async function fetchAllDataApiCoso(): Promise<any> {
  try {
    const headers = await buildHeaders(BASE_URL);
  const response = await fetch(`${BASE_URL}/coso`,{credentials: "include" ,method:"GET",headers});
  if (!response.ok) {
    throw new Error('Failed to fetch data');
  }
  return response.json();
} catch (error) {
  throw new Error('Failed to create jobTitle');
}


 
}



export async function fetchAllDataApiNist(): Promise<any> {
  try {
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/nist`,{credentials: "include" ,method:"GET",headers})
  if (!response.ok) {
    throw new Error('Failed to fetch data');
  }
  return response.json();
} catch (error) {
  throw new Error('Failed to fetch data');
}


 
}


export async function fetchDataApiRefrence(url: string, options: RequestInit = {}): Promise<any> {
    const headers = await buildHeaders(BASE_URL);
    try {
        const response = await fetch(`${BASE_URL}/${url}`, {
            ...options,
            headers,
            credentials: "include"
        });

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to fetch");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}
export async function fetchDataApiRisk(url: string, options: RequestInit = {}): Promise<any> {
  const headers = await buildHeaders(BASE_URL);
  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      ...options,
      headers,
      credentials: "include"
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
}


export async function fetchOneControlApi(url: string, options: RequestInit = {}): Promise<any> {
    const headers = await buildHeaders(BASE_URL);
    try {
        const response = await fetch(`${BASE_URL}/${url}`, {
            ...options,
            headers,  
            credentials: "include"
        });

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to fetch");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }

  
}



export async function updateControlApi(id: any, data: UpdateControlInput ): Promise<any> {
  try {
    const headers = await buildHeaders(BASE_URL);
    const response = await fetch(`${BASE_URL}/controls/${id}`, {
      credentials: "include",
      method: 'PATCH',
      headers,
      // Keep it compliance-scoped on every edit made from this app.
      body: JSON.stringify({ ...data, appScope: "compliance" }),
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to update control: ${response.status} ${response.statusText} - ${errorText}`);
    }
    
    // Always try to parse JSON response
    const responseText = await response.text();
    if (responseText.trim()) {
      try {
        const parsedResponse = JSON.parse(responseText);
        //console.log('Update control API response:', parsedResponse);
        return parsedResponse;
      } catch (parseError) {
        console.warn('Failed to parse JSON response, returning text:', responseText);
        return { success: true, message: responseText };
      }
    }
    
    // Return a success indicator if no content
    return { success: true, message: 'Control updated successfully' };
  } catch (error) {
    console.error('Update control error:', error);
    throw new Error(`Failed to update control: ${error instanceof Error ? error.message : 'Unknown error'}`);
  }
}
export async function fetchAllDataApiJopTitle(): Promise<any> {
    try {
        const headers = await buildHeaders(BASE_URL);
        const response = await fetch(`${BASE_URL}/jobTitles/getAll`, {
            credentials: "include" ,method: "GET",
            headers,
        });

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to fetch");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}

export async function fetchAllDataApiSystem(): Promise<any> {
    try {
        const headers = await buildHeaders(BASE_URL);
        const response = await fetch(`${BASE_URL}/systems/getAll`, {
            credentials: "include" ,method: "GET",
            headers,
        });

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to fetch");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}

export async function fetchAllDataApiProcess(): Promise<any> {
    try {
        const headers = await buildHeaders(BASE_URL);
        const response = await fetch(`${BASE_URL}/processes/getAll`, {
            credentials: "include" ,method: "GET",
            headers,
        });

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to fetch");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}
export async function fetchAllDataApiAssertion(): Promise<any> {
  try {
    const headers = await buildHeaders(BASE_URL);
  const response = await fetch(`${BASE_URL}/assertion`,{credentials: "include" ,method:"GET",headers});
  if (!response.ok) {
    throw new Error('Failed to fetch data');
  }
  return response.json();
} catch (error) {
  throw new Error('Failed to create jobTitle');
}
}

export async function fetchAllDataApiCobit(): Promise<any> {
  try {
    const headers = await buildHeaders(BASE_URL);
  const response = await fetch(`${BASE_URL}/cobit`,{credentials: "include" ,method:"GET",headers});
  if (!response.ok) {
    throw new Error('Failed to fetch data');
  }
  return response.json();
} catch (error) {
  throw new Error('Failed to create jobTitle');
}
}

export async function fetchAllDataApiIso(): Promise<any> {
  try {
    const headers = await buildHeaders(BASE_URL);
  const response = await fetch(`${BASE_URL}/iso`,{credentials: "include" ,method:"GET",headers});
 
 
  if (!response.ok) {
    throw new Error('Failed to fetch data');
  }
  return response.json();
} catch (error) {
  throw new Error('Failed to fetch data');
}
 
}



export async function createAssertionFromControlApi(body: CreateAssertionInput): Promise<void> {
    try {
        const headers = await buildHeaders(BASE_URL);
        const response = await fetch(`${BASE_URL}/assertion/fromControl`, {
            credentials: "include" ,method: "POST",
            headers,
            body: JSON.stringify(body),
        });

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to create");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}
export async function getStandards() {
  try {
    // Only the dashboard chart builder's Standard filter uses this: approved standards only.
    const response = await authService.apiCall(`${BASE_URL}/control-references?approvedOnly=true`, {
      method: "GET",
    });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to fetch standards');
  }
}

export async function getReport(standard: any, domain: any, subDomain: any, institution: any, complianceStatus: any, date: any) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/compliance-control-actions/report?standard=${standard}&domain=${domain}&subDomain=${subDomain}&institution=${institution}&complianceStatus=${complianceStatus}&date=${date}`, {
      method: 'GET',
    });
    if (!response.ok) {
      throw new Error('Failed to get report');
    }
    const result = await response.json();
    return result;
  } catch (error: any) {
    throw new Error(error?.message || 'Error fetching report');
  }
}

export async function getReferencesForSelect(params?: {
  query?: string;
  perPage?: number;
  pageNo?: number;
  sortBy?: string;
  sortOrder?: string;
}) {
  const url = `${BASE_URL}/control-references/getAll`;
  try {
    const response = await authService.apiCall(url, { method: 'GET' });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to fetch");
  }
}

export async function createControlBasic(
  controlId: string | number,
  payload: { name?: string; description?: string; objective?: string; type?: string }
): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/controls/basic`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    if (!response.ok || (data && data.success === false)) {
      if (response.status === 401 || response.status === 403 || (data && data.message === 'Forbidden access')) {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error('Failed to update control basic info');
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to update control basic info');
  }
}

export async function updateStandards(id: any, title: string) {
  try {
    const controlReferenceData = { name: title };
    const response = await authService.apiCall(`${BASE_URL}/control-references/${id}`, {
      method: "PATCH",
      body: JSON.stringify(controlReferenceData),
    });
    return response.json();
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to update standards');
  }
}

export async function getControl(controlId: string): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/controls/${controlId}`, {
      method: 'GET',
    });
    if (!response.ok) throw new Error('Failed to fetch data');
    return response.json();
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to fetch data');
  }
}

export async function updateControlBasic(
  controlId: string | number,
  payload: { name?: string; description?: string; objective?: string; type?: string }
): Promise<any> {
  try {
    const response = await authService.apiCall(
      `${BASE_URL}/update-basic/${controlId}`,
      { method: 'PATCH', body: JSON.stringify(payload) }
    );
    const data = await response.json();
    if (!response.ok || (data && data.success === false)) {
      if (
        response.status === 401 ||
        response.status === 403 ||
        (data && data.message === 'Forbidden access')
      ) {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error('Failed to update control basic info');
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to update control basic info');
  }
}
